// extracted by mini-css-extract-plugin
module.exports = {"base":"_3y62xO","preamble":"_1chn_W","align":"d4iq6H","secondary-text":"_2UNBDW","primary-text":"_3vM4uR","tint3":"_3_bZJd","tint4":"_2bWeAP","tint5":"CapHDe"};